import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '../index'

export interface IUiConfig {
    moduleName: any;
    footer: any;
    popKeyBoard: boolean;
}

@Module({ dynamic: true, store, name: 'uiConfig' })

export default class UiConfig extends VuexModule implements IUiConfig {
    public moduleName = {};
    public footer = {};
    public popKeyBoard = false;

    @Mutation
    setModuleName(moduleName: any) {
        this.moduleName = moduleName
    }

    @Mutation
    setFooter(footer: any) {
        this.footer = footer
    }

    @Mutation
    setPopKeyBoard(popKeyBoard: boolean) {
        this.popKeyBoard = popKeyBoard
    }
    

}
//getModule 将模块导出
export const UiConfigModule = getModule(UiConfig)
